import { Close, ErrorOutline, Phone } from '@mui/icons-material';
import { Grid, Typography } from '@mui/material';
import React from 'react';
import { useLwp } from '../../hooks/use-lwp';
import { formatUSPhoneNumber } from '../../utils/formatter';
import { AlertError, CallBox, CallButton, CallDetails, CallHeader, CallStateError } from './call-styles';
import CallWarningActions from './call-warning-actions';

export default function CallErrorNoMicPermissions() {
  const {
    hangupCall,
    phoneState: { phoneNumber, contactName, isErrorIgnored }
  } = useLwp();

  if (isErrorIgnored) return null;

  return (
    <CallBox data-testid="call-error-not-created">
      <CallHeader>
        <Grid container>
          <Grid item xs={6} zeroMinWidth>
            <CallStateError>ERROR</CallStateError>
            <Typography variant="h6" noWrap>
              {contactName ? contactName : ''}
            </Typography>
            <Typography variant="body2">{formatUSPhoneNumber(phoneNumber)}</Typography>
            <Typography variant="body2">--:--</Typography>
          </Grid>
          <Grid item xs={6} style={{ textAlign: 'right' }}>
            <CallButton
              disabled
              sx={{ backgroundColor: 'rgb(77, 206, 160)', '&:hover': { backgroundColor: 'rgb(77, 206, 160)' } }}
            >
              <Phone />
            </CallButton>
            <CallButton onClick={() => hangupCall()} palleteKey="secondary">
              <Close sx={{ fontSize: 32 }} />
            </CallButton>
          </Grid>
        </Grid>
        <AlertError icon={<ErrorOutline style={{ fontSize: 22, color: '#E31B0C' }} />} severity="error">
          You must grant permissions for this site to use your microphone. Once you grant permissions refresh the
          browser.
        </AlertError>
      </CallHeader>
      <CallDetails>
        <CallWarningActions phoneNumber={phoneNumber} />
      </CallDetails>
    </CallBox>
  );
}
